var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimbolo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mss-d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#10273B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234E70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mss-l",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8AB6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE0F7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mss-d)",
    d: "M25.94 0L28.5 0A1 1 0 0 1 29.5 1L29.5 12.95A3.5 3.5 0 0 1 27.75 15.98L19.2 20.91A6.4 6.4 0 0 0 16 26.46L16 26.5A3 3 0 0 1 13 29.5L1 29.5A1 1 0 0 1 0 28.5L0 25.94A24 24 0 0 1 7.03 8.97L8.97 7.03A24 24 0 0 1 25.94 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mss-d)",
    d: "M38.06 64L35.5 64A1 1 0 0 1 34.5 63L34.5 51.05A3.5 3.5 0 0 1 36.25 48.02L44.8 43.09A6.4 6.4 0 0 0 48 37.54L48 37.5A3 3 0 0 1 51 34.5L63 34.5A1 1 0 0 1 64 35.5L64 38.06A24 24 0 0 1 56.97 55.03L55.03 56.97A24 24 0 0 1 38.06 64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mss-l)",
    d: "M64 25.94L64 28.5A1 1 0 0 1 63 29.5L51 29.5A3 3 0 0 1 48 26.5L48 26.46A6.4 6.4 0 0 0 44.8 20.91L36.25 15.98A3.5 3.5 0 0 1 34.5 12.95L34.5 1A1 1 0 0 1 35.5 0L38.06 0A24 24 0 0 1 55.03 7.03L56.97 8.97A24 24 0 0 1 64 25.94Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mss-l)",
    d: "M0 38.06L0 35.5A1 1 0 0 1 1 34.5L13 34.5A3 3 0 0 1 16 37.5L16 37.54A6.4 6.4 0 0 0 19.2 43.09L27.75 48.02A3.5 3.5 0 0 1 29.5 51.05L29.5 63A1 1 0 0 1 28.5 64L25.94 64A24 24 0 0 1 8.97 56.97L7.03 55.03A24 24 0 0 1 0 38.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#16344E",
    d: "M33.25 20.02L41.75 24.93A2.5 2.5 0 0 1 43 27.09L43 36.91A2.5 2.5 0 0 1 41.75 39.07L33.25 43.98A2.5 2.5 0 0 1 30.75 43.98L22.25 39.07A2.5 2.5 0 0 1 21 36.91L21 27.09A2.5 2.5 0 0 1 22.25 24.93L30.75 20.02A2.5 2.5 0 0 1 33.25 20.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimbolo);
export default __webpack_public_path__ + "static/media/simbolo.a14368434f99652db6e081ad484e508c.svg";
export { ForwardRef as ReactComponent };